import WSClient from './tcms_base_client.js';

const client = new WSClient();
